var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "form",
      {
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.AUTH()
          },
        },
      },
      [
        _c("div", { staticClass: "form-group mb-2" }, [
          _c("small", { staticClass: "input-title" }, [
            _vm._v("Correo electrónico"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-group" },
            [
              _vm._m(1),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.email,
                    expression: "data.email",
                  },
                ],
                staticClass: "form-control",
                class: _vm.errors.email ? "is-invalid" : "",
                attrs: { type: "email", name: "email" },
                domProps: { value: _vm.data.email },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.data, "email", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _vm._l(_vm.errors.email, function (error, index) {
                return _c(
                  "small",
                  { key: index, staticClass: "invalid-feedback" },
                  [_vm._v(_vm._s(error))]
                )
              }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group mb-3" }, [
          _c("small", { staticClass: "input-title" }, [_vm._v("Contraseña")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-group" },
            [
              _vm._m(2),
              _vm._v(" "),
              _c("v-text-field", {
                staticClass: "form-control",
                class: _vm.errors.password ? "is-invalid" : "",
                attrs: {
                  name: "password",
                  "append-icon": _vm.type ? "mdi-eye" : "mdi-eye-off",
                  type: _vm.type ? "text" : "password",
                  "hide-details": "",
                },
                on: {
                  "click:append": function ($event) {
                    _vm.type = !_vm.type
                  },
                },
                model: {
                  value: _vm.data.password,
                  callback: function ($$v) {
                    _vm.$set(_vm.data, "password", $$v)
                  },
                  expression: "data.password",
                },
              }),
              _vm._v(" "),
              _vm._l(_vm.errors.password, function (error, index) {
                return _c(
                  "small",
                  { key: index, staticClass: "invalid-feedback" },
                  [_vm._v(_vm._s(error))]
                )
              }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group d-flex justify-content-end" }, [
          _c(
            "div",
            { staticClass: "mb-2 ml-auto mr-0" },
            [
              _c("router-link", { attrs: { to: { name: "ForgetPassword" } } }, [
                _vm._v("¿Olvidaste tu\n          contraseña?"),
              ]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-x w-100",
              attrs: { type: "submit" },
            },
            [
              _vm.count == 1
                ? _c(
                    "div",
                    {
                      staticClass: "spinner-border spinner-border-sm",
                      attrs: { role: "status" },
                    },
                    [
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("Loading..."),
                      ]),
                    ]
                  )
                : _c("span", [_vm._v("Iniciar sesión")]),
            ]
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "mt-4 d-flex justify-content-start gap-2" }, [
      _c(
        "div",
        { staticClass: "mb-3" },
        [
          _vm._v("¿No tiene una cuenta? "),
          _c("router-link", { attrs: { to: { name: "Register" } } }, [
            _vm._v("Afiliarme"),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-4 mb-5 text-left" }, [
      _c("h3", { staticClass: "text-lg mb-1" }, [
        _vm._v("Bienvenido de nuevo"),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "text-md text-muted" }, [
        _vm._v(
          "Inicia sesión para acceder a su casillero de compras internacionales."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "bi bi-envelope" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "bi bi-lock" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }